import { useState } from 'react'
import { X } from 'lucide-react'

interface MetricsModalProps {
  onClose: () => void
}

export function MetricsModal({ onClose }: MetricsModalProps) {
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4"
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      {/* Backdrop */}
      <div className="absolute inset-0 bg-bg/80 backdrop-blur-sm" onClick={onClose} />

      {/* Modal */}
      <div className="relative z-10 w-full max-w-lg card space-y-5 shadow-2xl">
        <div className="flex items-start justify-between gap-4">
          <h3 className="font-display text-2xl font-bold">
            ¿Cómo calculamos estas estadísticas?
          </h3>
          <button
            onClick={onClose}
            className="flex-shrink-0 h-8 w-8 rounded-lg flex items-center justify-center text-text-dim hover:text-text hover:bg-panel-elevated transition"
          >
            <X className="h-4 w-4" />
          </button>
        </div>

        <div className="space-y-4 text-sm text-text-dim leading-relaxed">
          <div>
            <h4 className="font-semibold text-text mb-1">📊 Solo sobre picks liquidados</h4>
            <p>
              Únicamente contabilizamos picks cuyo partido ya terminó y el resultado está confirmado.
              Un pick «pendiente» nunca entra en el cálculo.
            </p>
          </div>
          <div>
            <h4 className="font-semibold text-text mb-1">🏆 Win Rate</h4>
            <p>
              Número de Top Picks ganados dividido entre el total de Top Picks liquidados (ganados + perdidos).
              Solo se usa el Top Pick nº1 del día — no los secundarios.
            </p>
          </div>
          <div>
            <h4 className="font-semibold text-text mb-1">📈 ROI</h4>
            <p>
              Ganancia neta total dividida entre el stake total apostado en todos los picks.
              Asumimos stake unitario de 1 en cada pick para que la comparativa sea justa.
              Un ROI del 100% significa que por cada €100 apostados, has recuperado €200.
            </p>
          </div>
          <div>
            <h4 className="font-semibold text-text mb-1">✅ Auditoría</h4>
            <p>
              Los suscriptores ven exactamente los mismos datos dentro de la app que aparecen
              en esta landing. No existe ningún dato «interno» diferente.
            </p>
          </div>
        </div>

        <div className="pt-2 border-t border-border">
          <p className="text-xs text-text-dim">
            Estas métricas se actualizan automáticamente cada vez que un pick se liquida.
            Nunca mostramos estimaciones ni datos proyectados.
          </p>
        </div>
      </div>
    </div>
  )
}

export function useMetricsModal() {
  const [open, setOpen] = useState(false)
  return {
    open,
    openModal: () => setOpen(true),
    closeModal: () => setOpen(false),
    isOpen: open,
  }
}
